import React from 'react';
import { HeroSlideshow } from './HeroSlideshow';
import { QuickAccessPanel } from './QuickAccessPanel';

/**
 * Hero de Beaconsfield : illustration à gauche, rail « Vos accès rapides » à droite.
 *
 * ATNA ne vit plus dans une carte séparée : il est posé sur l'illustration elle-même,
 * dans `HeroSlideshow`. Leur question « Que recherchez-vous aujourd'hui ? » a donc
 * disparu — la barre ATNA la remplace, sans l'annoncer.
 *
 * La colonne de droite est en `minmax(320px, 26%)` et non en fraction fixe : à 1024 px,
 * un quart ne laisse que 256 px, insuffisant pour les capitales de « Vos accès rapides ».
 *
 * Pas de hauteur fixe : les deux colonnes grandissent avec leur contenu, le rail avec
 * ses dix entrées et l'illustration avec la pile titre + ATNA + pagination.
 */
export function HomeHero() {
  return <section aria-label="En vedette" className="w-full" data-id="element-1793" data-mp="3fry13ozmntqq">
      <div className="grid lg:min-h-[34rem] lg:grid-cols-[minmax(0,1fr)_minmax(20rem,26%)]" data-id="element-1794" data-mp="3kjpl1goa317w">
        <HeroSlideshow data-id="element-1795" data-mp="ov8pl03mpvop" />
        <QuickAccessPanel data-id="element-1796" data-mp="oupf24gb69kp" />
      </div>
    </section>;
}